import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Paragraph = ({ node }: RichTextContentProps) => {
  return (
    <p>
      <RichTextContent node={node} />
    </p>
  );
};

export default Paragraph;
